import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
export const useBanGuildValidationSchema = () => {
    const { t } = useTranslation();
    return Yup.object().shape({
        reason: Yup.string().required(`Reason ${t('is_required')}`),
        numberOfDays: Yup.string()
            .matches(/(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/, t('only_numbers_are_allowed'))
            .required(`Number ${t('is_required')}`)
    });
};
